export const DOCUMENT_SCORING_HISTORY_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.ScoringHistory.DocumentScoringHistoryInvalidated";
